export enum Country {
  USA = 'USA',
  Canada = 'Canada'
}
